export const TIME_OUT = 30000;

export const METHOD = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE",
  PATCH: "PATCH",
};

export const SETTING = {
  // OFFICIAL
  DOMAIN_API: "https://api.pioneswap.com",
  DOMAIN_FE: "https://pioneswap.com",
  DOMAIN_NFT: "https://api.nft.pionewallet.com",


  // LOCAL
  // DOMAIN_API: "http://localhost:3211",
  // DOMAIN_NFT: "https://api.nft.pionewallet.com",
  // DOMAIN_NFT: "http://localhost:8386",
  // DOMAIN_FE: "https://nowswap.toearnnow.com",

  // TEST
  // DOMAIN_API: "https://api.pioneswap.tocuna.com",
  // DOMAIN_FE: "https://pioneswap.tocuna.com",
  // DOMAIN_NFT: "https://api.nft.pionewallet.com",
};
